import React from 'react';

class SpinnerLoader extends React.Component {

    render() {
        return (<div className="spinner-overlay"><div className="eq-spinner"><i/></div></div>);
    }

}

export default SpinnerLoader;


// WEBPACK FOOTER //
// ./src/components/spinnerLoader/spinnerLoader.js